import { Infer, object, string } from "superstruct";

export const NudgesApplicationConfigSchema = object({
    nudgesWidgetPlaceholderSelector: string(),
});

export type NudgesApplicationConfigInterface = Infer<
    typeof NudgesApplicationConfigSchema
>;
